import { Link } from "react-router-dom";
import { FileQuestion, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 text-center">
      <div className="inline-flex items-center justify-center rounded-full bg-slate-100 p-4 text-slate-600 mb-6">
        <FileQuestion className="h-12 w-12" />
      </div>
      <h1 className="text-4xl font-bold tracking-tight text-brand-blue-dark sm:text-5xl mb-4">
        404 - Siden blev ikke fundet
      </h1>
      <p className="text-lg text-slate-600 max-w-md mx-auto mb-8">
        Beklager, vi kunne ikke finde den side, du leder efter. Den er muligvis blevet flyttet eller slettet.
      </p>
      <div className="flex justify-center gap-4">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-brand-blue px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-brand-blue-light transition-colors cursor-pointer"
        >
          <ArrowLeft className="h-4 w-4" />
          Gå til forsiden
        </Link>
      </div>
    </div>
  );
}
